import { ApiService } from "./ApiService";

interface ManageBillingResponse {
  url: string;
}

interface PayDepositResponse {
  url: string;
}

interface PayInvoiceResponse {
  url: string;
}

interface InvoiceStatusResponse {
  success: boolean;
  isPaid: boolean;
  status: string;
  invoiceNumber: string;
  paidAt: string | null;
}

export class BillingService {
  constructor(private readonly apiService: ApiService) {}

  async manageBilling(): Promise<ManageBillingResponse> {
    return this.apiService.request<ManageBillingResponse>("/billing/manage", {
      method: "GET",
      requireAuth: true,
    });
  }

  async payDeposit(
    serviceOrderId: string,
    invoiceId: string
  ): Promise<PayDepositResponse> {
    return this.apiService.request<PayDepositResponse>("/billing/pay-deposit", {
      method: "POST",
      body: JSON.stringify({ serviceOrderId, invoiceId }),
      requireAuth: true,
    });
  }

  async payInvoice(invoiceId: string): Promise<PayInvoiceResponse> {
    return this.apiService.request<PayInvoiceResponse>("/billing/pay-invoice", {
      method: "POST",
      body: JSON.stringify({ invoiceId }),
      requireAuth: true,
    });
  }

  async checkInvoiceStatus(invoiceId: string): Promise<InvoiceStatusResponse> {
    return this.apiService.request<InvoiceStatusResponse>(
      `/billing/invoice-status/paid/${invoiceId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }
}
